var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.36566C10.8472 4.2658 10.3369 3.2467 9.5479 2.46535C8.75888 1.68399 7.73485 1.18374 6.63354 1.04163C5.53224 0.899528 4.41476 1.12346 3.45325 1.67894C2.49174 2.23442 1.73953 3.09062 1.3125 4.11566M1 1.61566V4.11566H3.5M1 6.61566C1.15285 7.71553 1.66308 8.73462 2.4521 9.51598C3.24112 10.2973 4.26515 10.7976 5.36646 10.9397C6.46776 11.0818 7.58524 10.8579 8.54675 10.3024C9.50826 9.74691 10.2605 8.8907 10.6875 7.86566M11 10.3657V7.86566H8.5",
    stroke: "#71758F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.bb26c52b43ada9f9f5c9cff4ebf389f9.svg";
export { ForwardRef as ReactComponent };